import React from 'react'
import s from './StatusPill.module.scss'

export const StatusPill = ({ children, tone }) => {
	const resolvedTone = tone || String(children || '').toLowerCase().replace(/\s+/g, '-')
	return (
		<span className={`${s['status-pill']} ${s[`status-pill--${resolvedTone}`] || ''}`.trim()}>
			{children}
		</span>
	)
}
